module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcp-article"
    }
  }, [(_vm.initialLoad) ? _c('mu-content-block', {
    staticClass: "contentLoader"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.initialLoad) ? _c('article', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "blueTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.article.post_title))
    }
  }), _vm._v(" "), (_vm.article.post_format === 'video') ? _c('figure', {
    staticClass: "media"
  }, [_c('mu-circular-progress', {
    staticClass: "loader",
    attrs: {
      "size": 36
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.article.post_video_iframe, {
        allowedAttributes: {
          'iframe': ['width', 'height', 'allow', 'frameborder', 'src', 'webkitallowfullscreen', 'mozallowfullscreen', 'allowfullscreen']
        }
      }))
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "75",
      "desktop": "75"
    }
  }, [_c('mu-card', [_c('mu-card-text', [_c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.article.post_content))
    }
  }), _vm._v(" "), (_vm.hasReferences) ? _c('mu-raised-button', {
    staticClass: "smoothBtn primary",
    attrs: {
      "id": "viewReferencesBtn",
      "label": _vm.toggle.references ? 'Hide References' : 'View References',
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.toggleReferences()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasReferences && _vm.toggle.references),
      expression: "hasReferences && toggle.references"
    }],
    staticClass: "references"
  }, [_c('ol', _vm._l((_vm.article.post_references), function(reference, refIndex) {
    return _c('li', {
      key: ("reference-" + refIndex),
      class: {
        'active': _vm.activeReference === refIndex + 1
      },
      attrs: {
        "id": ("reference-" + (refIndex + 1))
      }
    }, [_c('a', {
      attrs: {
        "href": reference.reference_url,
        "target": "_blank"
      },
      domProps: {
        "textContent": _vm._s(reference.reference_title)
      }
    })])
  }), 0)]), _vm._v(" "), (_vm.hasFurtherReading) ? _c('div', {
    staticClass: "further-reading"
  }, [_c('h3', [_vm._v("Further Reading")]), _vm._v(" "), _c('ol', _vm._l((_vm.article.post_further_reading), function(further, furtherIndex) {
    return _c('li', {
      key: ("further-" + furtherIndex)
    }, [_c('a', {
      attrs: {
        "href": further.further_reading_url,
        "target": "_blank"
      },
      domProps: {
        "textContent": _vm._s(further.further_reading_title)
      }
    })])
  }), 0)]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('mu-card', {
    staticStyle: {
      "padding": "0 20px"
    },
    attrs: {
      "id": "similar"
    }
  }, [_c('h4', [_vm._v("Similar articles")]), _vm._v(" "), _vm._l((_vm.similar.per_page), function(dummy, dummyIndex) {
    return (_vm.similar.isLoading) ? _c('div', {
      key: ("dummy-" + dummyIndex),
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "img",
      attrs: {
        "size": 15,
        "color": "#d9d9d9"
      }
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "title",
      attrs: {
        "size": 10,
        "color": "#d9d9d9"
      }
    }), _vm._v(" "), _c('mu-linear-progress', {
      attrs: {
        "size": 10,
        "color": "#d9d9d9"
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.similar.articles), function(article, articleIndex) {
    return (!_vm.similar.isLoading) ? _c('article', {
      key: ("article-" + articleIndex)
    }, [(article.post_format === 'video') ? _c('figure', {
      staticClass: "media"
    }, [_c('mu-circular-progress', {
      staticClass: "loader",
      attrs: {
        "size": 36
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/hcp/article/' + article.post_slug
      }
    }, [_c('img', {
      attrs: {
        "src": article.post_video_thumb
      }
    })])], 1) : _vm._e(), _vm._v(" "), _c('h3', {
      staticClass: "title"
    }, [_c('router-link', {
      attrs: {
        "to": '/hcp/article/' + article.post_slug
      },
      domProps: {
        "textContent": _vm._s(article.post_title)
      }
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "textContent": _vm._s(article.post_video_desc)
      }
    })]) : _vm._e()
  })], 2)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d96c466c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HealthCareProfessional/Article/Article.vue
// module id = 3296
// module chunks = 1